import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

class SiteManagement extends Component {

	constructor(props) {
        super(props);
        this.state = {
			options: [{
				label: '-- Select --',
				value: '',
			}, {
				label: 'Manage Assets',
				value: '/siteManagement/manageAssets',
			}, {
				label: 'Create Token Account',
				value: '/siteManagement/createTokenAccount',
			}, {
				label: 'Delete Returns',
				value: '/siteManagement/deleteReturns',
			}, {
				label: 'Rebates And Claim Forms',
				value: '/siteManagement/rebatesAndClaimForms',
			}, {
				label: 'Price Export Message',
				value: '/siteManagement/priceExportMessage',
			}, {
				label: 'Manage Non GEA SSO Users',
				value: '/siteManagement/nonGEASSOUsers',
			}, {
				label: 'File Uploads',
				value: '/siteManagement/fileUploads',
			}],
			selectedOption: '',
        }
    }

	componentWillMount() {
		const self = this;
		const { userDetails } = self.props.state.user;
		// redirect user to home page if he has not access to this page
		if(userDetails && !userDetails.isSiteManagementAccess) {
			browserHistory.push('/home');
		}
	}

	handleChange(e) {
		browserHistory.push(e.target.value);
	}

    render() {
		const self = this;
		const { options, selectedOption } = self.state;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">Site Management</h1>
				</div>
				<strong>Select Site Management:</strong> <select onChange={this.handleChange} value={selectedOption}>
					{options.map((item, index) => (
						<option key={ index } value={ item.value }>{ item.label }</option>
					))}
				</select>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

SiteManagement = connect(mapStateToProps)(SiteManagement);
export default SiteManagement;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/index.js